import '@/styles/treasury.css'
import '@/styles/global.scss'

import type { AppProps } from 'next/app'
import { Provider as RollbarProvider, ErrorBoundary } from '@rollbar/react'

import { rollbarConfig } from '@/clients/rollbar'
import store from '../store'
import { StoreProvider } from 'easy-peasy'

export default function App({ Component, pageProps }: AppProps) {
    return (
        <RollbarProvider config={rollbarConfig}>
            <ErrorBoundary>
                <StoreProvider store={store}>
                    <Component {...pageProps} />
                </StoreProvider>
            </ErrorBoundary>
        </RollbarProvider>
    )
}